<template>
  <button
    :class="[
      typeClasses,
      sizeClasses,
      fullWidthClasses,
      roundClasses,
      disabledClasses,
      {
        [loadingClasses]: loading,
      },
    ]"
    @click="$emit('click')"
    v-bind="$attrs"
    :disabled="disabled"
    :type="htmlType"
  >
    <slot />
  </button>
</template>

<script>
import ButtonMixin from '@/mixins/Button';

const SIZE_CLASSES = {
  small: 'text-[1rem] leading-[1rem] px-[16px] py-[8px] border-[1.5px] focus:outline-blue',
  large: 'text-[1.125rem] leading-[1.5rem] px-[20px] py-[8px] border-[2px] focus:outline-blue',
};

const SIZE_CLASSES_WITH_IMAGE = {
  small:
    'text-[1rem] leading-[1rem] px-[16px] py-[11px] border-[1.5px] focus:outline-blue flex items-center',
  large:
    'text-[1.125rem] leading-[1.5rem] px-[20px] py-[12px] border-[2px] focus:outline-blue flex items-center',
};

const ROUND_CLASSES = {
  normal: 'rounded-[12px]',
  less: 'rounded-[8px]',
};

export default {
  mixins: [ButtonMixin],

  props: {
    round: {
      type: String,
      validator(value) {
        return ['normal', 'less'].includes(value);
      },
      default: 'normal',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    withImage: {
      type: Boolean,
      default: false,
    },
    solidClasses: {
      type: [String, Array, Object],
      default: 'bg-[#080A6E] border-[#080A6E] text-white hover:bg-[#0E11BE] hover:border-[#0E11BE]',
    },
    outlineClasses: {
      type: [String, Array, Object],
      default:
        'bg-transparent border-[#080A6E] hover:text-white hover:bg-[#0E11BE] hover:border-[#0E11BE]',
    },
    borderlessClasses: {
      type: [String, Array, Object],
      default:
        'border-0 border-transparent hover:bg-black hover:bg-opacity-10 hover:border-transparent active:border-transparent hover:bg-[#0E11BE] hover:border-[#0E11BE]',
    },
    widthClasses: {
      type: [String, Array, Object],
      default: 'min-w-[32px] inline-flex',
    },
    htmlType: {
      type: String,
      validator(value) {
        return ['button', 'submit', 'reset'].includes(value);
      },
      default: 'button',
    },
  },

  computed: {
    sizeClasses() {
      const classes = this.withImage ? SIZE_CLASSES_WITH_IMAGE : SIZE_CLASSES;
      return classes[this.size];
    },
    roundClasses() {
      return ROUND_CLASSES[this.round];
    },
    fullWidthClasses() {
      return this.fullWidth ? ' flex w-full justify-center ' : this.widthClasses;
    },
  },
};
</script>
